export default class UtilService {
  static getErrorMessage = (e: any): string => {
    console.log(e);
    return e?.response?.data?.message
      ? e.response.data.message
      : e.message || "An error occurred, please try again later.";
  };

  // static getConfirmation = async (msg: string): Promise<boolean> => {
  //   return new Promise((resolve) => {
  //     if (confirm("Press a button!") === true) {
  //       resolve(true);
  //     } else {
  //       resolve(false);
  //     }
  //   });
  // };

  static showMessage = async (msg: string) => {
    alert(msg);
  };
}
